import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/mobile/lib/sendAnalyticsEvent/index';

import {CHECKOUT_DELIVERY_STEP} from 'constants/analytics/events/checkout';

/**
 *  Sends an analytic event for non-US state shipping methods.
 */
export const sendNonUSStateAnalytic = (shippingHits: string[]) => {
    sendDesktopAnalyticsEvent(
        CHECKOUT_DELIVERY_STEP,
        {
            message: 'Location - State - Non USA',
        },
        false,
        {
            availableShippingMethods: `${shippingHits}`.trim(),
        },
    );
};

/**
 *  Sends an analytic event for US state shipping methods.
 */
export const sendUSStateAnalytic = (state: string, shippingHits: string[]) => {
    const stateValue = `${state === 'California' ? 'California' : 'USA (Non California)'}`;
    if (state !== '0')
        sendDesktopAnalyticsEvent(
            CHECKOUT_DELIVERY_STEP,
            {
                message: `Location - State - ${stateValue}`,
            },
            false,
            {
                availableShippingMethods: `${shippingHits}`.trim(),
            },
        );
};
